module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-insurance-4e8f36f39d6278051cb6fdcec2d6d6b5.webp";